import React, { useEffect, useState, useCallback } from 'react';
import { db } from '../db/firebase.js';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const actionMeta = {
    ids_added:      { label: 'IDs Added',      className: 'admin-badge-green' },
    id_removed:     { label: 'ID Removed',     className: 'admin-badge-red' },
    cron_triggered: { label: 'Cron Triggered', className: 'admin-badge-yellow' },
};

const formatTs = (iso) => {
    if (!iso) return '—';
    return new Date(iso).toLocaleString();
};

const AdminActivityLog = () => {
    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const snap = await getDoc(doc(db, 'config', 'activityLog'));
            if (snap.exists()) {
                const raw = snap.data().entries || [];
                setEntries([...raw].reverse()); // most recent first
            } else {
                // Create the document so future writes work
                await setDoc(doc(db, 'config', 'activityLog'), { entries: [] });
                setEntries([]);
            }
        } catch (err) {
            console.error('AdminActivityLog load error:', err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    if (loading) return <div className="admin-loading">Loading activity log...</div>;

    return (
        <div className="admin-section">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
                <h2 className="admin-section-title" style={{ borderBottom: 'none', paddingBottom: 0 }}>
                    Activity Log
                </h2>
                <button className="admin-btn admin-btn-ghost" onClick={load} disabled={loading}>
                    ↻ Refresh
                </button>
            </div>

            {entries.length === 0 ? (
                <p className="admin-muted">No activity recorded yet. Actions like adding IDs or triggering the cron will appear here.</p>
            ) : (
                <div className="admin-log-list">
                    {entries.map((entry, i) => {
                        const meta = actionMeta[entry.action] || { label: entry.action, className: 'admin-badge-gray' };
                        return (
                            <div key={i} className="admin-log-entry">
                                <span className="admin-log-ts">{formatTs(entry.ts)}</span>
                                <span className={`admin-badge ${meta.className}`}>{meta.label}</span>
                                <span className="admin-log-detail">{entry.detail}</span>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default AdminActivityLog;
